import React, { useEffect, useState, useRef } from 'react';
export function Cursor() {
  const flameRef = useRef<HTMLDivElement>(null);
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    const isTouch = window.matchMedia('(hover: none)').matches || window.innerWidth <= 1024;
    if (isTouch) return;
    setEnabled(true);
    const flame = flameRef.current;
    if (!flame) return;
    let flameX = -200;
    let flameY = -200;
    let targetX = -200;
    let targetY = -200;
    let visible = false;
    let rafId = 0;
    const tick = () => {
      flameX += (targetX - flameX) * 0.15;
      flameY += (targetY - flameY) * 0.15;
      flame.style.left = flameX - 14 + 'px';
      flame.style.top = flameY - 38 + 'px';
      rafId = requestAnimationFrame(tick);
    };
    const onFirstMove = (e: MouseEvent) => {
      targetX = e.clientX;
      targetY = e.clientY;
      flameX = targetX;
      flameY = targetY;
      if (!visible) {
        flame.classList.add('visible');
        visible = true;
        tick();
      }
      document.removeEventListener('mousemove', onFirstMove);
      document.addEventListener('mousemove', onMove);
    };
    const onMove = (e: MouseEvent) => {
      targetX = e.clientX;
      targetY = e.clientY;
    };
    document.addEventListener('mousemove', onFirstMove);
    const onLeave = () => {
      flame.classList.remove('visible');
      visible = false;
    };
    const onEnter = () => {
      flame.classList.add('visible');
      visible = true;
    };
    document.addEventListener('mouseleave', onLeave);
    document.addEventListener('mouseenter', onEnter);
    const onOver = (e: MouseEvent) => {
      const target = (e.target as HTMLElement).closest('a, button, .producto-card, .objeto-card, .tab-btn, .selector-btn, .var-btn, .section-nav__item, .pilar, .wa-float');
      if (target) flame.classList.add('is-hover');
    };
    const onOut = (e: MouseEvent) => {
      const target = (e.target as HTMLElement).closest('a, button, .producto-card, .objeto-card, .tab-btn, .selector-btn, .var-btn, .section-nav__item, .pilar, .wa-float');
      const related = (e.relatedTarget as HTMLElement | null)?.closest('a, button, .producto-card, .objeto-card, .tab-btn, .selector-btn, .var-btn, .section-nav__item, .pilar, .wa-float');
      if (target && target !== related) flame.classList.remove('is-hover');
    };
    document.addEventListener('mouseover', onOver);
    document.addEventListener('mouseout', onOut);
    return () => {
      document.removeEventListener('mousemove', onFirstMove);
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseleave', onLeave);
      document.removeEventListener('mouseenter', onEnter);
      document.removeEventListener('mouseover', onOver);
      document.removeEventListener('mouseout', onOut);
      cancelAnimationFrame(rafId);
    };
  }, []);
  if (!enabled) return null;
  return <div className="cursor-flame" id="cursorFlame" ref={flameRef} data-id="element-114" data-mp="1ko6cmxdv9o4l">
      <svg width="28" height="40" viewBox="0 0 28 40" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-115" data-mp="248y93i2aj6i0">
        <rect x="9" y="28" width="10" height="12" rx="1" fill="rgba(246,244,239,0.9)" stroke="#C4A882" strokeWidth="0.8" data-id="element-116" data-mp="289h1bd83iekq" />
        <line x1="14" y1="28" x2="14" y2="24" stroke="#8B8E8A" strokeWidth="0.8" strokeLinecap="round" data-id="element-117" data-mp="1zbolm7ygp4wt" />
        <path d="M14 3 C14 3 19 8 20 13 C21 17 19 20 17 22 C16 23 15 24 14 24 C13 24 12 23 11 22 C9 20 7 17 8 13 C9 8 14 3 14 3Z" fill="rgba(196,168,130,0.85)" stroke="#C4A882" strokeWidth="0.5" data-id="element-118" data-mp="1pcz0857cx2bt" />
        <path d="M14 10 C14 10 16.5 13 17 16 C17.5 18.5 16 21 14 22 C12 21 10.5 18.5 11 16 C11.5 13 14 10 14 10Z" fill="rgba(78,95,82,0.5)" data-id="element-119" data-mp="11m3e9opl11ch" />
        <ellipse cx="14" cy="18" rx="2" ry="3" fill="rgba(246,244,239,0.6)" data-id="element-120" data-mp="16n0sxrbdvd98" />
        <path d="M13 12 C13 12 13.5 10 14 9" stroke="rgba(246,244,239,0.7)" strokeWidth="0.8" strokeLinecap="round" data-id="element-121" data-mp="29vamo40okdwh" />
      </svg>
    </div>;
}